import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { Globals } from 'app/_globals';
import { CookieService } from 'ngx-cookie-service';
import { StoreService } from '../../_services/store.service';
import { environment } from '../../../environments/environment';
import { StripeService } from 'app/_services/stripe.service';
import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-store-payment-setup',
    templateUrl: './store-payment-setup.component.html',
    styleUrls: ['./store-payment-setup.component.css'],
})
export class StorePaymentSetupComponent implements OnInit {
    tabitems: any = [];

    storeId: any;
    selectedStore: any;
    cookieStore: any;
    storeForm: FormGroup;

    role: any;
    routeRole: any;

    stripePlatform: any = environment.stripe;

    stripeProcessing: any;

    storeStripeInfo: any = null;

    constructor(
        public fb: FormBuilder,
        public activatedRoute: ActivatedRoute,
        public loader: LoadingBarService,
        public notificationService: NotificationService,
        public globals: Globals,
        public cookieService: CookieService,
        public router: Router,
        public _storeService: StoreService,
        public _stripeService: StripeService,
        public confirmationService: ConfirmationService
    ) {
        const hasCurrentStore = cookieService.check('currentStore');
        if (hasCurrentStore) {
            this.cookieStore = JSON.parse(cookieService.get('currentStore'));
            this.storeId = this.cookieStore.id;
        } else {
            this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
        }

        this.role = globals.user.role;
        this.routeRole = globals.user.routeRole;

        this.tabitems = [
            { path: '/' + this.routeRole + '/store/details', title: 'Details' },
            { path: '/' + this.routeRole + '/store/location', title: 'Location' },
            { path: '/' + this.routeRole + '/store/opening-times', title: 'Ordering Times' },
            { path: '/' + this.routeRole + '/store/media', title: 'Media' },
            { path: '/' + this.routeRole + '/store/payment-setup', title: 'Payment Setup' },
            { path: '/' + this.routeRole + '/store/pos-setup', title: 'POS Setup' },
            { path: '/' + this.routeRole + '/store/services', title: 'Services' },
        ];
    }

    ngOnInit() {
        this.getStore(this.storeId);
    }

    // Get Store by id
    public getStore(id) {
        this._storeService.getStoreById(id).subscribe(
            (data: any) => {
                // console.log('Selected Store -> ', data);
                this.selectedStore = data;
                if (data.paymentConfig) {
                    if (data.paymentConfig.stripeAccountId) {
                        this.getStripeAccount(this.storeId);
                    }
                }
                if (
                    data.storeConfig !== null &&
                    data.storeConfig.deliveryOrders &&
                    this.tabitems.filter((item) => item.title === 'Delivery Times').length === 0
                ) {
                    this.tabitems.push({
                        path: '/' + this.routeRole + '/store/delivery-times',
                        title: 'Delivery Times',
                    });
                } else if (
                    data.storeConfig !== null &&
                    data.storeConfig.deliveryOrders === false &&
                    this.tabitems.filter((item) => item.title === 'Delivery Times').length === 1
                ) {
                    this.tabitems.splice(
                        this.tabitems.findIndex((item) => item.title === 'Delivery Times'),
                        1
                    );
                }
                if (
                    data.storeConfig !== null &&
                    data.storeConfig.kioskOrders &&
                    this.tabitems.filter((item) => item.title === 'Kiosks').length === 0
                ) {
                    this.tabitems.push({ path: '/' + this.routeRole + '/store/kiosks', title: 'Kiosks' });
                } else if (
                    data.storeConfig !== null &&
                    data.storeConfig.kioskOrders === false &&
                    this.tabitems.filter((item) => item.title === 'Kiosks').length === 1
                ) {
                    this.tabitems.splice(
                        this.tabitems.findIndex((item) => item.title === 'Kiosks'),
                        1
                    );
                }
            },
            (err) => {
                console.log('Getting store by ID error, navigate to select store');
                this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
            }
        );
    }

    public getStripeAccount(id) {
        this._stripeService.getStripeAccountForStore(id).subscribe((data: any) => {
            // console.log(data);
            this.storeStripeInfo = data;
        });
    }

    // Function to start the stripe connect process
    connectStripe() {
        const status = 'processing';
        localStorage.setItem('stripe_process', status);
        this.stripeProcessing = true;
        window.addEventListener('storage', this.storageEventListener.bind(this));

        const popup_window = window.open(
            'https://connect.stripe.com/oauth/authorize?response_type=code&amp;client_id=' +
            this.stripePlatform.client_id +
            '&amp;scope=read_write&amp;state=' +
            this.storeId
        );
    }

    private storageEventListener(event: StorageEvent) {
        if (event.storageArea === localStorage) {
            if (event.newValue === 'finished') {
                localStorage.removeItem('stripe_process');
                this.stripeProcessing = false;
                this.getStore(this.storeId);
            }
        }
    }

    removeStripeFromStore(id) {
        this.confirmationService.confirm({
            message: 'Are you sure you wish to disconnect from stripe?',
            accept: () => {
                this._stripeService.removeStripeFromStore(id).subscribe((data: any) => {
                    this.getStore(this.storeId);
                    this.notificationService.notify(
                        'success',
                        'Stripe Disconnected',
                        'You have sucessfully disconnected Stripe from this store',
                        'top',
                        'right'
                    );
                });
            },
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/indi-store/payment-setup/store-payment-setup.component.ts